//Dependecies
import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import 'aframe';
import { Entity, Scene } from 'aframe-react';
import '../../../scripts/internal-look-controls';

/* 360 PREVIEW VIEWER */
const Virtual01 = (props) =>
{
  const { panoURL, isMobile } = props;

  const [list01, setList01] = useState(null);
  const [panoLoading, setPanoLoading] = useState(true);

  /* ONE PANORAMA */
  useEffect(() =>
  {
    let imageList = 
    
      <a-assets>
        <img 
          alt         = 'true' 
          id          = 'pano'
          crossOrigin = 'anonymous'
          src         = {panoURL}
          onLoad      = {() => setTimeout(() => 
                                {
                                  setPanoLoading(false)
                                }, 200)}
        />
      </a-assets>
    
    setList01(imageList);    
  }, [panoURL]);

  return(
    <React.Fragment>
      <div 
        style = 
          {{
            height : '100%',
            width : '100%', 
          }}

        id            = 'virtualcontainer'
      >
        {panoLoading &&
          <div
            className = 'fixed absolute flex justify-center items-center flex-col z-[10000] bg-gray-900 bg-opacity-60`'
            style = 
            {{
              width : document.getElementById('virtualcontainer') ? document.getElementById('virtualcontainer').getBoundingClientRect().width : '', 
              height : document.getElementById('virtualcontainer') ? document.getElementById('virtualcontainer').getBoundingClientRect().height : '', 
            }}
          >
            <Spin size = "large"/>
            <span
              className ='flex justify-center mt-4 lg:text-2xl md:text-xl text-white font-semibold'
            >
              SE ESTÁ CARGANDO EL PANORAMA
            </span>
          </div>
        }
          
        {list01 &&
          <Scene 
            device-orientation-permission-ui = "enabled: false" 
            disable-inspector 
            touchEnabled 
            vr-mode-ui = "enabled:false;" 
            id = "myEmbeddedScene" 
            embedded
            raycaster = "objects: .raycastable"
            loading-screen = "dotsColor: white; backgroundColor: black" 
          > 
            <Entity 
              primitive = "a-sky" 
              height = "1024"
              width = "1024"
              src = {`#pano`}
            />
            
            {list01}

            <a-camera 
              fov                     = {90}
              position                = "0 1.6 0" 
              wasd-controls           = 'enabled: false' 
              internal-look-controls  = {`enabled: true; autorotateSpeed: ${isMobile ? '0.002' : '0.001'};`}
              look-controls           = 'enabled: false'
            >
              <a-entity
                cursor = "rayOrigin: mouse; fuseTimeout: 0;"
                raycaster = "objects: .box"
              />
            </a-camera>
          </Scene>
        }
      </div>
    </React.Fragment>
  )
}

export default Virtual01;